import type { FC } from "react"
import "./styles.css"

interface BikeIconProps {
  className?: string
  fill?: string
  width?: string | number
  height?: string | number
  "aria-label"?: string
  role?: string
}

export const BikeIcon: FC<BikeIconProps> = ({ className, fill, width, height, "aria-label": ariaLabel, role }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width || "21"}
    height={height || "16"}
    viewBox="0 0 21 16"
    fill={fill ? fill : "#BAFD4F"}
    aria-label={ariaLabel}
    role={role}
  >
    <path d="M15.3294 3.67001C16.1412 3.67001 16.7994 3.01187 16.7994 2.20001C16.7994 1.38815 16.1412 0.730011 15.3294 0.730011C14.5175 0.730011 13.8594 1.38815 13.8594 2.20001C13.8594 3.01187 14.5175 3.67001 15.3294 3.67001Z" />
    <path d="M4.48078 15.39C2.04078 15.39 0.0507812 13.4 0.0507812 10.96C0.0507812 8.52 2.04078 6.53 4.48078 6.53C6.92078 6.53 8.91078 8.52 8.91078 10.96C8.91078 13.4 6.92078 15.39 4.48078 15.39ZM4.48078 7.75C2.71078 7.75 1.26078 9.19 1.26078 10.97C1.26078 12.75 2.70078 14.19 4.48078 14.19C6.26078 14.19 7.70078 12.75 7.70078 10.97C7.70078 9.19 6.26078 7.75 4.48078 7.75Z" />
    <path d="M16.1995 15.39C13.7595 15.39 11.7695 13.4 11.7695 10.96C11.7695 9.98 12.0895 9.05 12.6795 8.27C12.8795 8 13.2595 7.95 13.5295 8.16C13.7995 8.36 13.8495 8.74 13.6395 9.01C13.2095 9.57 12.9795 10.25 12.9795 10.96C12.9795 12.73 14.4195 14.18 16.1995 14.18C17.9795 14.18 19.4195 12.74 19.4195 10.96C19.4195 9.64 18.6295 8.47 17.4095 7.98C17.0995 7.85 16.9495 7.5 17.0795 7.19C17.2095 6.88 17.5595 6.73 17.8695 6.86C19.5495 7.54 20.6295 9.15 20.6295 10.96C20.6295 13.4 18.6395 15.39 16.1995 15.39Z" />
    <path d="M16.14 6.74002C16.14 7.19002 15.78 7.55002 15.33 7.55002H12.7C12.25 7.55002 11.89 7.19002 11.89 6.74002V4.83002H9.04L10.9 6.91002C11.03 7.06002 11.1 7.25002 11.1 7.45002V11.98C11.1 12.43 10.74 12.79 10.29 12.79C9.84 12.79 9.48 12.43 9.48 11.98V7.76002L6.41 4.33002C6.35 4.27002 6.31 4.19002 6.27 4.12002C6.1 3.86002 6 3.56002 6 3.22002C6 2.33002 6.72 1.61002 7.61 1.61002H11.91C12.8 1.61002 13.52 2.33002 13.52 3.22002C13.52 3.35002 13.5 3.48002 13.47 3.60002V5.94002H15.3C15.75 5.94002 16.11 6.30002 16.11 6.75002L16.14 6.74002Z" />
  </svg>
)
